const productCodes = {
    data: {
        "product_codes":
            [
                "claim_#_1",
                "claim_#_2",
                "claim_#_3",
                "claim_#_4",
                "claim_#_5",
                "claim_#_6",
                "claim_#_7",
                "claim_#_8",
                "claim_#_9",
                "claim_#_10",
                "claim_#_11",
                "claim_#_12",
                "claim_#_13",
                "claim_#_14",
                "claim_#_15",
                "claim_#_16",
                "claim_#_17",
                "claim_#_18",
                "claim_#_19",
                "claim_#_20",
                "claim_#_21",
                "claim_#_22",
                "claim_#_23",
                "claim_#_24",
                "claim_#_25",
                "claim_#_26",
                "claim_#_27",
                "claim_#_28",
                "claim_#_29",
                "claim_#_30",
                "claim_#_31"
            ], "language": "ru", "etag": new Date().getTime()
    }
};
export default productCodes;